var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03572 17.5713L28.9643 17.5713C29.5363 17.5713 30 17.1076 30 16.5356L30 2.03557C30 1.46357 29.5363 0.999861 28.9643 0.999861L2.03572 0.999861C1.46371 0.999861 1 1.46357 1 2.03557L1 16.5356C1 17.1076 1.46371 17.5713 2.03572 17.5713Z",
    stroke: "#404041",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14284 23.7859H25.8571M3.07141 20.6787H27.9286H3.07141Z",
    stroke: "#404041",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.4643C18.36 14.4643 20.6786 12.1458 20.6786 9.28575C20.6786 6.4257 18.36 4.10718 15.5 4.10718C12.6399 4.10718 10.3214 6.4257 10.3214 9.28575C10.3214 12.1458 12.6399 14.4643 15.5 14.4643Z",
    stroke: "#404041",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.17857C28.6266 6.17857 27.3094 5.63297 26.3382 4.6618C25.367 3.69063 24.8214 2.37344 24.8214 1M1 6.17857C1.68006 6.17857 2.35346 6.04462 2.98175 5.78438C3.61005 5.52413 4.18093 5.14268 4.6618 4.6618C5.14268 4.18093 5.52413 3.61005 5.78438 2.98175C6.04462 2.35346 6.17857 1.68006 6.17857 1M30 12.3929C28.6266 12.3929 27.3094 12.9385 26.3382 13.9096C25.367 14.8808 24.8214 16.198 24.8214 17.5714M1 12.3929C1.68006 12.3929 2.35346 12.5268 2.98175 12.7871C3.61005 13.0473 4.18093 13.4288 4.6618 13.9096C5.14268 14.3905 5.52413 14.9614 5.78438 15.5897C6.04462 16.218 6.17857 16.8914 6.17857 17.5714",
    stroke: "#404041",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.d5d01828a27f319dc9e269c1dcdf3ed7.svg";
export { ForwardRef as ReactComponent };